import { Mail } from 'lucide-react';
import type { JSX } from 'react';

import { MetaMask } from '~/icons/metamask';
import { Whatsapp } from '~/icons/whatsapp';
import type { OriginName } from '~/interfaces/common';

export type IconComponent = () => JSX.Element;
type AuthProvider = {
  id: string;
  icon: IconComponent;
};
type OriginValue = AuthProvider | AuthProvider[];

const isMetaMaskInstalled = window.ethereum?.isMetaMask;

export const getOrigins = () => {
  const origins = {
    'bloque-whatsapp': {
      id: 'whatsapp',
      icon: Whatsapp,
    },
    'bloque-email': {
      id: 'email',
      icon: Mail as any,
    },
  } as Record<OriginName, OriginValue>;

  if (isMetaMaskInstalled) {
    origins.evm = [
      {
        id: 'MetaMask',
        icon: MetaMask,
      },
    ];
  }

  return origins;
};
